module.exports = __webpack_public_path__ + "static/media/5.21_preview.842db261.png";